import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import { CURRENT_USER_QUERY_KEY, getCurrentUser } from '../api';
import type { CurrentUser } from '../api/model';

type Selector<SelectorReturnType> = (currentUser: CurrentUser | undefined) => SelectorReturnType;

export const useCurrentUser = <SelectorReturnType = CurrentUser>(
  selector?: Selector<SelectorReturnType>,
): UseQueryResult<SelectorReturnType, Error> => {
  return useQuery(CURRENT_USER_QUERY_KEY, getCurrentUser, {
    select: selector,
    staleTime: 60 * 60 * 1000,
    cacheTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
